import CurrencySumComponent from "./CurrencySumComponent";

export default CurrencySumComponent;
